var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"logo",style:(Object.assign({}, _vm.customStyle(),
    {backgroundImage: _vm.generateBackgroundImage(),
    backgroundColor: _vm.generateBackgroundColor()}))},[(_vm.userName && !_vm.generateBackgroundImage())?_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.userName)+" ")]):_vm._e(),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }